/**
 * Builds the URL for embedding a Miro board via an api integration.
 *
 * @param {string} boardId   The Miro board ID.
 *
 * @returns {string} result  The embed URL.
 */
const buildMiroEmbedURL = (boardId) => {

	return `https://miro.com/app/live-embed/${boardId}`;

};

export {
	buildMiroEmbedURL,
};
